import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import FormLegacyHelper from "@Scripts/Infrastructure/FormLegacyHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "ProductRequest" })
export default class ProductRequest extends Vue {
    public isLoading: boolean = false;
    public isSuccess: boolean = false;

    public productCategories: any[] = [];
    public provinces: any[] = [];
    public locations: any[] = [];
    public isPrivacyPolicyShow: boolean = false;
    public privacyPolicy: string = null;

    public productRequestSubmit: any = { province: null, location: null, schoolType: null };

    public validationErrors: any[] = [];

    @Prop() readonly recaptchaSiteKey: string;

    @Watch("productRequestSubmit.province") onProvinceChanged(value: any, oldValue: any) {
        if (!value) {
            this.locations = [];
            this.productRequestSubmit.province = null;
        } else if (value !== oldValue) {
            this.getLocations();
        }
    }

    get routes() {
        return (<any>window).App.routes;
    }

    get requestText() {
        return (<any>window).App.bag.RequestText;
    }

    get isAuthenticated() {
        return (<any>window).App.bag.IsAuthenticated;
    }

    public async created() {
        await Promise.all([this.getProductCategories(), this.getProvinces(), this.getPrivacyPolicy()]);

        if (this.requestText) {
            this.productRequestSubmit.requestText = this.requestText;
        }

        if (this.isAuthenticated === "True") {
            await this.getUserProfile();
        }
        this.setRecaptcha();
    }

    public setRecaptcha() {
        let recaptchaScript = document.createElement("script");
        recaptchaScript.setAttribute("src", "https://www.recaptcha.net/recaptcha/api.js");
        document.head.appendChild(recaptchaScript);
    }

    public async getUserProfile() {
        let response = (await this.$store.dispatch("catalogueStore/getUserProfile")).data;

        if (response) {
            this.productRequestSubmit.schoolType = response.schoolType;
            this.productRequestSubmit.province = response.province;
            this.productRequestSubmit.name = response.name;
            this.productRequestSubmit.surname = response.surname;
            this.productRequestSubmit.email = response.email;
            this.productRequestSubmit.phone = response.phone;
            this.productRequestSubmit.institute = response.institute;
        }
    }

    public async getProductCategories() {
        let response = await this.$store.dispatch("catalogueStore/getProductCategories");

        if (response) {
            this.productCategories = response.data;
        }
    }

    public async getProvinces() {
        let response = await this.$store.dispatch("salesNetStore/getProvinces");

        if (response) {
            this.provinces = response.data;
        }
    }

    public async getLocations() {
        if (this.productRequestSubmit.province) {
            let response = await this.$store.dispatch("salesNetStore/getLocations", {
                provinceCode: this.productRequestSubmit.province
            });

            if (response.data) {
                this.locations = response.data;

                if (response.data.length === 1) {
                    this.productRequestSubmit.location = response.data[0].value;
                }
            }
        }
        else {
            this.locations = null;
        }
    }

    public async getPrivacyPolicy() {
        let response = await this.$store.dispatch("supportStore/getPrivacyPolicy");

        if (response) {
            this.privacyPolicy = response.data.description;
        }
    }

    public showPrivacyPolicy() {
        if (!this.isPrivacyPolicyShow) {
            this.isPrivacyPolicyShow = true;
            document.getElementById("PrivacyPolicyBox").classList.remove("hden");
        } else {
            this.isPrivacyPolicyShow = false;
            document.getElementById("PrivacyPolicyBox").classList.add("hden");
        }
    }

    public async setProductRequestSubmit() {
        this.validationErrors = [];
        this.isLoading = true;
        FormLegacyHelper.resetValidation();

        try {
            let response = (await Axios.post(this.routes.Catalogue_ProductRequest, this.productRequestSubmit, { headers: { "RecaptchaVerificationToken": (<any>window).grecaptcha.getResponse() } })).data;

            this.isSuccess = true;
            GTagHelper.sendEvent("form_submit", "essay_request");

        } catch (error) {
            FormLegacyHelper.resetValidation();

            if (error.response) {
                if (error.response.status === 400) {
                    let validationState = error.response.data;
                    FormLegacyHelper.setValidation(validationState);

                    for (var propertyName in error.response.data) {
                        if (error.response.data.hasOwnProperty(propertyName)) {
                            for (let message of error.response.data[propertyName]) {
                                this.validationErrors.push({ message: message });
                            }
                        }
                    }
                }
            }
        }
        this.isLoading = false;

        (<any>window).grecaptcha.reset();
    }

    public closeModal() {
        let lgData = (<any>window).parent.lgData;
        for (let propertyName in lgData) {
            if (propertyName !== "uid" && lgData.hasOwnProperty(propertyName)) {
                if (lgData[propertyName].lGalleryOn) {
                    lgData[propertyName].destroy();
                }
            }
        }
    }
};